module.exports = __webpack_public_path__ + "assets/media/RIGHT_ARROW_WITH_TEXT.07d43d58.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/RIGHT_ARROW_WITH_TEXT.svg
// module id = 1999
// module chunks = 0